import React from 'react';
import Cart from './containers/Cart';
import ProductList from './containers/ProductList';

//const  usernameRef = require('./Login.js');

//document.getElementById('text').innerHTML = usernameRef;

const App = () => {
    return (
        
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h1>Welcome to demo Energy commerce portal</h1>
                
                </div>
            </div>
            <div className="row">
                <div className="col-md-8">
                    <ProductList />
                </div>
                <div className="col-md-4">
                    <Cart />
                </div>
            </div>

            <footer>
                <small>
                    made by for a demo, original source code available on <a href="https://github.com/krzysu/reactjs-shopping-cart">github</a>
                </small>
            </footer>
        </div>
    );
}

export default App;
